<template>
    <div class="d-block">
        <Tabs value="name1">
        <TabPane label="软件注册信息" name="name1">
            <h1>注册人：海南睿脑医疗科技有限公司</h1>
            <h1>地址：海南省海口市国家高新技术产业开发区南海大道266号创业孵化中心A楼5层A29-794室</h1>
            <h1>完整版本号：V1.0.0.0</h1>
            <h1>生产日期：</h1>
            <h1>生产批号：</h1>
        </TabPane>
        <TabPane label="用户协议" name="name2">用户协议</TabPane>
        <TabPane label="说明书" name="name3">说明书</TabPane>
    </Tabs>
        <Modal width="420" v-model="changeModal.show" :title="changeModal.title + '管理员'" @on-cancel="onCancel">
            <Form :label-width="80" v-if="changeModal.show">
                <FormItem label="姓名">
                    <Input v-model="changeModal.data.userName"/>
                </FormItem>
                <FormItem label="手机号">
                    <Input v-model="changeModal.data.loginName" type="number" :disabled="changeModal.kind === 2 ? true : false"/>
                </FormItem>
                <FormItem label="新密码">
                    <Input type="password" v-model="changeModal.data.password"/>
                </FormItem>
                <FormItem label="状态">
                    <Select v-model="changeModal.data.status">
                        <Option :value="1">启用</Option>
                        <Option :value="2">禁用</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="onCancel">取消</Button>
                <Button type="primary" @click="onConfirm(changeModal.data, changeModal.kind)">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                search: {},

                tableColumns: [
                    {
                        title: '姓名',
                        slot: 'userName',
                    },
                    {
                        title: '手机号',
                        key: 'loginName',
                    },
                    {
                        title: '状态',
                        slot: 'status',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 106,
                    }
                ],
                tableData: [],

                total: 0,
                page: 1,
                count: 15,

                changeModal: {},
            }
        },
        async mounted() {
            await this.getAdmin(this.page);
        },
        methods: {
            async getAdmin(page){
                this.page = page;
                let query = '&status=' + (this.search.status || '') + '&userName=' + (this.search.userName || '');
                let res = await this.$api.getHttp('admin/user/list?page=' + this.page + '&pageSize=' + this.count + query);
                console.log('this.getAdmin---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.tableData = [] = res.data.data.rows;
                this.total = res.data.data.total;
            },

            async onChange(data, index, kind){
                debugger
                console.log('this.onChange---------->', data, index, kind);
                this.changeModal = {} = {
                    show: true,
                    title: kind === 1 ? '添加' : '编辑',
                    kind: kind,
                    data: kind === 1 ? {
                        logo: '',
                    } : data,
                }
            },

            async onCancel(){
                this.changeModal = {};
                this.getAdmin(this.page);
            },
            async onConfirm(data, kind){
                debugger
                console.log('this.onConfirm---------->', data, kind);
                if (!data.userName || data.userName === ''){
                    return this.$Message.error('姓名不能为空');
                }
                if (!data.loginName || data.loginName === ''){
                    return this.$Message.error('手机号不能为空');
                }
                if (kind === 1){
                    if ((!data.password || data.password === '')){
                        return this.$Message.error('密码不能为空');
                    }
                    if (Number(data.password) === 0){
                        return this.$Message.error('密码不能以0开头');
                    }
                }
                if (!data.status || data.status === ''){
                    return this.$Message.error('状态不能为空');
                }

                let res;
                if (kind === 1){
                    res = await this.$api.postHttp('admin/user/add', data);
                }
                if (kind === 2){
                    res = await this.$api.putHttp('admin/user/edit', data);
                }
                console.log('this.onConfirm---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.$Message.success(res.data.msg);
                this.onCancel();
            },
            async onDelete(data, index, kind){
                debugger
                console.log('this.onDelete---------->', data, index, kind);
                let com = await this.$common.confirmModel('是否确认删除');
                if (!com) return;

                let res = await this.$api.deleteHttp('admin/user/delete?id=' + data.id);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.$Message.success(res.data.msg);
                this.getAdmin(this.page);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/about/index.vue